<template>
  <TrainingProcessLog
    :extra-params="extraParams"
    :visible="visible"
    :extra-id="$attrs['extra-id']"
    api-url="/workspace/manager/training/expertVerify/expertProcessLog"
    log-type-name="专家预审" />
</template>

<script>
import TrainingProcessLog from '../../common/TrainingProcessLog'
export default {
  name: 'TrainingExpertVerifyProcessLog',
  components: {
    TrainingProcessLog
  },
  props: {
    extraParams: Object,
    visible: Boolean
  }
}
</script>
